/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A wrapper around the `XMLHttpRequest` constructor.
 *
 * @publicApi
 */
export abstract class XhrFactory {
  abstract build(): XMLHttpRequest;
}



// WEBPACK FOOTER //
// ../../../../../packages/common/src/xhr.ts